import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import OfferListOfferTile from 'components/OfferList/OfferListTiles/OfferListOfferTile'
import OneClickBookingRestorationBanner from './OneClickBookingRestorationBanner'

interface Props {
  offerId: string
  transactionKey: string
  filters: App.OfferListFilters
  searchTileDensity?: SearchTileDensity
  showPerNightPricing?: boolean
}

function OneClickBookingRestorationTile({
  offerId,
  transactionKey,
  filters,
  searchTileDensity,
  showPerNightPricing = false,
}: Props) {
  return <OfferListOfferTile
    offerId={offerId}
    position={0}
    eagerLoadImage
    filters={filters}
    tileStyle="search"
    wrapperClass="offer-tile"
    searchTileDensity={searchTileDensity}
    showPerNightPricing={showPerNightPricing}
    oneClickBookingRestorationBanner={<OneClickBookingRestorationBanner transactionKey={transactionKey} />}
  />
}

export default OneClickBookingRestorationTile
